import React, { ReactElement } from 'react';
import { RootState } from 'store';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import EditItemName from '../../Common/Components/EditItemName';
import BackArrow from '../../../assets/img/icons/BackArrow.svg';
import { getQueryParam } from 'utils';
import useQuery from '../../../hooks/useQuery';
import InfoPopover from './InfoPopover';

interface IStickyHeaderContentProps {
  label: string;
  subLabel?: string;
  showBack?: boolean;
  automationLabel?: string;
  backButtonUrl?: string;
  showInfoIcon?: boolean;
  infoText?: string | ReactElement;
}
const StickyHeaderContent: React.FC<IStickyHeaderContentProps> = ({
  label,
  subLabel,
  showBack,
  children,
  automationLabel,
  backButtonUrl,
  showInfoIcon,
  infoText,
}) => {
  const isOnCreateAutomation: boolean = window.location.pathname.includes('details');
  const history = useHistory();
  let query = useQuery();
  const path = window.location.pathname;

  const backArrowClickHandler = () => {
    const workflowId = getQueryParam('workflow_id');
    const fromParam = getQueryParam('from');
    const formId = getQueryParam('form_id');
    if (workflowId.length > 0) {
      let redirect = query.get('redirect');
      if (redirect === 'automation') {
        history.push(`/automation?fromId=${workflowId}`);
      } else {
        history.push(`/automation/details?workflow_id=${workflowId}${fromParam && `&from=${fromParam}`}`);
      }
    } else if ((formId && fromParam === 'forms') || ((path.endsWith('forms') || path.endsWith('forms/')) && formId)) {
      history.push('/settings/forms');
    } else if (path.endsWith('forms') && !formId) {
      history.push('/settings');
    } else {
      history.goBack();
    }
  };
  return (
    <ContentContainer>
      <div className={`d-flex justify-content-between full-width ${subLabel ? ' header-sub-label' : null}`}>
        <div className={`label-container flex-grow-1 ${subLabel ? 'flex-column align-items-start' : null}`}>
          {showBack && (
            <div className="d-flex flex-row bottom-margin back-pointer">
              <img src={BackArrow} alt="<" onClick={backArrowClickHandler} />
              <div className="verticalLine top-margin"></div>
            </div>
          )}
          <h1 className="label-header">{label}</h1>
          {subLabel && <span className="sub-label-header">{subLabel}</span>}
          {/* {automationLabel && (
            <div className="automation-label-header">
              <EditItemName itemName={workflowName} />
            </div>
          )} */}
          {/* {isOnCreateAutomation ? (
            <div className="automation-input-header d-flex">
              <EditItemName
                itemName={workflowName}
                submitHandler={(value) => nameUpdateHandler(value, workflowId)}
              />
            </div>
          ) : null} */}
          {path.includes('settings/forms') && showInfoIcon && infoText ? (
            <InfoPopover placement="bottomLeft" infoText={infoText} width={366} className="info-icon" />
          ) : null}
        </div>
        <div>{children}</div>
      </div>
    </ContentContainer>
  );
};

export default StickyHeaderContent;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  .full-width {
    width: 100%;
    justify-content: space-between;
    &.header-sub-label {
      padding-top: 24px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        padding-top: 16px;
      }
    }
  }
  .automation-save-btn {
    margin-right: 10px;
    height: 34px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 30px;
    }
  }
  .back-pointer {
    align-items: center;
    img {
      cursor: pointer;
      margin-left: 2px;
      // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      //   width: 16px;
      // }
    }
    .verticalLine {
      height: 24px;
      width: 1px;
      stroke-width: 1px;
      padding: 0;
      background: #ddd;
      margin: 0 11px;
    }
  }
  .search-icon-contianer {
    height: 90%;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 50%;
  }

  .label-container {
    display: flex;
    justify-content: start;
    height: 100%;
    align-items: center;
    .info-icon {
      margin-left: 8px;
    }
  }
  .label-header {
    color: #424b50;
    font-size: 36px;
    font-weight: 700;
    line-height: 47px;
    margin-bottom: 0px;
    letter-spacing: -1px;
    display: block;
    font-family: 'Roboto Slab';
    white-space: nowrap;
    // @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    //   font-size: 28px;
    //   line-height: 33px;
    // }
  }
  .sub-label-header {
    color: #424b50;
    font-size: 16px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 0px;
    display: block;
    font-family: 'Roboto Slab', serif;
    white-space: nowrap;
    margin-top: -10px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
      line-height: 33px;
    }
  }
  .automation-label-header {
    margin-left: 10px;
    padding-left: 15px;
    border-left: 1px solid #dddddd;
    padding-top: 5px;
    min-width: calc(100% - 250px);
    height: 25px;
    #editable-name-wrapper {
      margin-top: -8px;
      .email-name-box .email-name {
        color: #001823;
        font-size: 16px !important;
        font-weight: 400;
        font-family: 'Roboto', serif;
      }
    }
  }
  .automation-input-header {
    margin-left: 10px;
    padding-left: 15px;
    border-left: 1px solid #dddddd;
    padding-top: 5px;
    height: 45px;
    min-width: 200px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      height: 34px;
    }
    label {
      margin: 0;
    }
    input {
      /* padding-top: 4px; */
      padding-bottom: 4px;
      @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
        /* padding-top: 6px; */
        padding-bottom: 6px;
      }
    }
    input,
    button {
      /* margin-top: -10px; */
    }
    #editable-name-wrapper {
      > div:first-child {
        display: none !important;
      }
    }
  }
`;
